import { Link } from 'react-router-dom';
import { getLatestUpdates } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestSection() {
  const latestComics = getLatestUpdates();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-800">
              <i className="ri-timer-line text-primary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">每日同步更新，精彩不容错过</p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5" data-product-shop>
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}